export function TheFollowIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="24" cy="16" r="8" />
      <path d="M10 40c0-8 6-14 14-14s14 6 14 14" />
      <path d="M32 22l4 4 6-6" />
    </svg>
  );
}
